import { Languages } from "lucide-react";

/**
 * Small floating language toggle, used ONLY on /login and /register.
 * Shows the *next* language code (e.g. "EN" while currently AR, "ع" while EN).
 */
export default function LangToggle({ lang, onToggle, t }) {
    return (
        <button
            type="button"
            onClick={onToggle}
            aria-label={t.toggleAria}
            className="absolute top-4 z-20 inline-flex h-9 items-center gap-1.5 rounded-full border border-neutral-200 bg-white/90 px-3 text-xs font-bold uppercase tracking-wider text-neutral-700 shadow-sm backdrop-blur transition hover:-translate-y-0.5 hover:border-amber-300 hover:bg-white hover:text-amber-700 sm:top-6"
            style={lang === "ar" ? { left: "1rem" } : { right: "1rem" }}
            data-testid="auth-lang-toggle"
        >
            <Languages className="h-3.5 w-3.5" />
            <span data-testid="auth-lang-toggle-label">{t.toggleNext}</span>
        </button>
    );
}
